export default __webpack_public_path__ + "static/media/photo_gallery_10.1601091e.png";